import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false


//引入全局样式（包括重置）
import './assets/css/common.css'

//自定义全局组件
import wGlobal from './components/global/index'
Vue.use(wGlobal)

let vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vue